import React from "react";
import currentTheme from "../../../react-themes/theme";
import FarmyAnchoredDialog from "../../topLayer/popovers/FarmyAnchoredDialog";
import {FarmyCloseIcon} from "../../../react-components/shared/SharedComponents";

const DialogPDP = (props) => {
  const {children, onClose, style, className = "", ...additionalProps} = props;
  const theme = currentTheme();

  return <FarmyAnchoredDialog
    onClose={onClose}
    className={`
      farmy-anchored-dialog
      full-width
      soft-shadow
      background-color-white
      border-radius-lg
      border-default
      ${className}
    `}
    style={{
      padding: "40px 20px 20px",
      right: "0",
      borderColor: theme.colors.farmy.orange,
      ...style
    }}
    {...additionalProps}
  >
    {!additionalProps?.hideCloseBtn && <FarmyCloseIcon
      onClick={onClose}
      className="position-absolute cursor-pointer"
      style={{
        top: "15px",
        right: "15px"
      }}
    />}
    {children}
  </FarmyAnchoredDialog>;
};

export default DialogPDP;
